<template>
    <div class="date-filter date-filter-container">
        <div class="holder">
            <div class="input-container">
                <Datepicker
                    v-tooltip="{
                        content: haveValue ? filterDisplayText : null,
                        distance: '5',
                        delay: { show: 500, hide: 100 },
                    }"
                    range
                    :model-value="filterValue"
                    calendar-class-name="date-picker-calendar"
                    menu-class-name="date-picker-menu"
                    input-class-name="date-picker-input"
                    :multi-calendars="true"
                    :position="lastColumn ? 'left' : 'center'"
                    :is24="false"
                    :enable-time-picker="false"
                    :data-cy="`filter.datepicker`"
                    @update:modelValue="onFilter"

                />
            </div>
        </div>
    </div>
</template>

<script>
import { capitalize } from 'lodash-es';
import Datepicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css';
import moment from 'moment';

export default {
    name: 'DateFilter',
    components: {
        Datepicker,
    },
    props: {
        columnName: {
            type: String,
            default: '',
        },
        columnLabel: {
            type: String,
            default: '',
        },
        displayFormat: {
            type: String,
            default: 'MM/DD/YY',
        },
        filterState: {
            type: Object,
            default: () => {},
        },
        lastColumn: {
            type: Boolean,
            default: false,
        },
        dateFilterType: {
            type: String,
            default: 'date range'
        },
    },
    data() {
        return {
            filterValue: null,
            filterType: this.dateFilterType,
            defaultFilter: null,
            filterText: 'Date Range Filter',
        };
    },
    computed: {
        detail() {
            return {
                filterColumn: this.columnName,
                filterValue: this.filterOutputValue,
                filterType: this.filterType,
                filterLabel: this.columnLabel,
                filter: 'date',
            };
        },
        haveValue() {
            return this.filterValue?.length > 0;
        },
        filterDisplayText() {
            if (!this.haveValue) return this.filterText;

            let formattedStartDate = moment(this.filterValue[0]).format(
                this.displayFormat
            );
            let formattedEndDate = moment(this.filterValue[1]).format(
                this.displayFormat
            );

            return `${formattedStartDate} - ${formattedEndDate}`;
        },
        filterOutputValue() {
            if (!this.haveValue) return null;

            let startDateTime = this.normalizeDateForApi(this.filterValue[0]);
            let endDateTime = this.normalizeDateForApi(
                this.filterValue[1],
                true
            );

            return `${startDateTime}|${endDateTime}`;
        },
        capFilterType() {
            return capitalize(this.filterType);
        },
    },
    watch: {
        filterState: {
            handler() {
                this.setupFilters();
            },
            deep: true,
        },
    },
    mounted() {
        this.clearFilter();

        this.setupFilters();
    },
    methods: {
        setupFilters() {
            if (!this.filterState || !this.filterState.filterValue) {
                this.clearFilter();

                return;
            }
            this.setFilter();
        },
        clearFilter() {
            this.filterValue = this.defaultFilter;
        },
        onFilter(modelData) {
            this.filterValue = modelData;
            this.$emit('onFilter', this.detail);
        },
        normalizeDateForApi(date, endOfDay = false) {
            let output = moment(date);

            // Forcing startDate 00:00:00.000 and endDate: 23:59:59.999
            endOfDay ? output.endOf('day') : output.startOf('day');

            return output.format('YYYY-MM-DDTHH:mm:ss.SSSZZ');
        },
        // resetFilter() {
        //     this.clearFilter();
        //     this.onFilter(this.detail);
        // },
        setFilter() {
            const dateRange = this.filterState.filterValue.split('|');

            this.filterValue = [moment(dateRange[0]), moment(dateRange[1])];
        },
    },
};
</script>

<style lang="scss">
.date-picker-calendar {
    .dp__range_start,
    .dp__range_end {
        background: $tealDark;
    }
    .dp__action.dp__select {
        color: $tealDark;
    }
    .dp__today {
        border-color: $tealDark;
    }
}
.date-picker-menu {
    .dp__action.dp__select {
        color: $tealDark;
    }
}
.date-picker-input {
    &.dp__input {
        border: none;
        padding-left: 30px;
        padding-right: 26px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
    &.dp__input_icons {
        padding-right: 12px;
        padding-left: 12px;
    }
}
.date-filter {
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: flex-end;
    flex-wrap: wrap;

    .bold {
        width: 100%;
    }

    .holder {
        width: 100%;
        display: flex;
        justify-content: flex-start;
        align-items: flex-end;
    }

    .input-container {
        position: relative;
        width: 100%;
        background-color: white;
        border-radius: 4px;
        border: 1px solid $grey01;
        padding: 3px 0;
        line-height: 18px;
        &:hover {
            border-color: $tealDark;
        }
    }

    .type-selection-container {
        width: calc(100% - 20px);
        display: flex;
        padding-bottom: 8px;

        .filter-type {
            font-size: 10px;
            color: $grey04;
            padding: 4px 10px 0px 5px;
            white-space: nowrap;
            text-overflow: ellipsis;
        }
    }
}
</style>
